<div class="content-block">

  <!-- Content Header (Page header) -->

  <div class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          <h1 class="m-0 text-dark">Magazzino</h1>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
            <li class="breadcrumb-item">Magazzino</li>
            <li class="breadcrumb-item active">Riepilogo riordino</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->


  <section class="col-lg-12 ">

    <div class="card primary">
      <div class="card-header">
        <h3 class="card-title">
          <i class="fa fa-chart-pie mr-1"></i>
          <span>Riepilogo riordino</span>
        </h3>

      </div><!-- /.card-header -->
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-lg-8">
            <div class="row">
              <!--<div class="col-xl-4 col-lg-6 col-sm-12 col-xs-12 mb-6">
              <div class="dx-field">
                <div class="dx-field-label">Categoria</div>
                <div class="dx-field-value">
                  <dx-lookup
                    displayExpr="descrizione"
                    valueExpr="id"
                    [dataSource]="listCategorie"
                    [searchEnabled]="true"
                    [(value)]="idCategoriaFilter"
                    (onValueChanged)="onCategoriaSelected($event)"
                    >
                  </dx-lookup>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-6 col-sm-12 col-xs-12 mb-6">
              <div class="dx-field">
                <div class="dx-field-label">Tipologia</div>
                <div class="dx-field-value">
                  <dx-lookup
                    displayExpr="descrizione"
                    valueExpr="id"
                    [dataSource]="listTipiArticoli"
                    [searchEnabled]="true"
                    [(value)]="idTipologiaFilter"
                    (onValueChanged)="onTipologiaSelected($event)"
                    >
                  </dx-lookup>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-4 col-lg-6 col-sm-12 col-xs-12 mb-6">
              <div class="dx-field">
                <div class="dx-field-label">Sito</div>
                <div class="dx-field-value">
                  <dx-lookup
                    displayExpr="descrizione"
                    valueExpr="id"
                    [dataSource]="listSiti"
                    [searchEnabled]="true"
                    [(value)]="idSitoFilter"
                    (onValueChanged)="onSitoSelected($event)"
                    >
                  </dx-lookup>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-6 col-sm-12 col-xs-12 mb-6">
              <div class="dx-field">
                <div class="dx-field-label">Reparto</div>
                <div class="dx-field-value">
                  <dx-lookup
                    displayExpr="descrizione"
                    valueExpr="id"
                    [dataSource]="listReparti"
                    [searchEnabled]="true"
                    [(value)]="idRepartoFilter"
                    (onValueChanged)="onRepartoSelected($event)"
                    >
                  </dx-lookup>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-4 col-lg-6 col-sm-12 col-xs-12 mb-6">
              <div class="dx-field">
                <div class="dx-field-label">Responsabile</div>
                <div class="dx-field-value">
                  <dx-lookup
                    displayExpr="nominativo"
                    valueExpr="idDipendente"
                    [dataSource]="listResponsabili"
                    [searchEnabled]="true"
                    [(value)]="idResponsabileFilter"
                    (onValueChanged)="onResponsabileSelected($event)"
                    >
                  </dx-lookup>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-6 col-sm-12 col-xs-12 mb-6">
              <div class="dx-field">
                <div class="dx-field-label">Mansione</div>
                <div class="dx-field-value">
                  <dx-lookup
                    displayExpr="descrizione"
                    valueExpr="id"
                    [dataSource]="listMansioni"
                    [searchEnabled]="true"
                    [(value)]="idMansioneFilter"
                    (onValueChanged)="onMansioneSelected($event)"
                    >
                  </dx-lookup>
                </div>
              </div>
            </div>
            -->
            <div class="col-xl-4 col-lg-6 col-sm-12 col-xs-12 mb-6">
              <dx-button
                stylingMode="contained"
                text="Carica"
                icon="fa fa-calculator"
                type="success"
                width="120"
                (onClick)="onBtnCaricaCalcoliClick()">
              </dx-button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <!--<li class="nav-item" role="presentation">
            <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-target="#det-ass" type="button" role="tab" aria-controls="det-ass" aria-selected="true">Dettaglio Assegnazioni</button>
          </li>-->
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="id-mod-rio-tab" data-bs-toggle="tab" data-target="#mod-rio" type="button" role="tab" aria-controls="mod-rio" aria-selected="true">Modello</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="id-rie-rio-tab" data-bs-toggle="tab" data-target="#rie-rio" type="button" role="tab" aria-controls="rie-rio" aria-selected="false">Riepilogo per Riordino</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="id-anomalie-tab" data-bs-toggle="tab" data-target="#anomalie" type="button" role="tab" aria-controls="anomalie" aria-selected="false">Anomalie</button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <!--
          <div class="tab-pane fade show active" id="det-ass" role="tabpanel" aria-labelledby="det-ass-tab">
            <dx-data-grid #dataGridAssegnazioni [dataSource]="listDettaglioCorrente" [showBorders]="true"
              [focusedRowEnabled]="false" [columnAutoWidth]="true" [wordWrapEnabled]="false"
              [rowAlternationEnabled]="false" [allowColumnResizing]="true"
              [allowColumnReordering]="true" (onExporting)="onExportingGridAssegnazioni($event)">
              <dxo-search-panel [visible]="false"></dxo-search-panel>

              <dxo-group-panel [visible]="true"></dxo-group-panel>
              <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>

              <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

              <dxo-filter-row [visible]="false"></dxo-filter-row>

              <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>

              <dxo-export [enabled]="true"></dxo-export>

              <dxo-paging [pageSize]="20"></dxo-paging>

              <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 20, 50]"></dxo-pager>
            </dx-data-grid>
          </div>-->
          <div class="tab-pane fade show active" id="mod-rio" role="tabpanel" aria-labelledby="mod-rio-tab">
            <app-modulo-riordino></app-modulo-riordino>
          </div>
          <div class="tab-pane fade" id="rie-rio" role="tabpanel" aria-labelledby="rie-rio-tab">

            <dx-data-grid #dataGridRiepilogo [dataSource]="riepilogoRiordinoFisso?.listRiordino" [showBorders]="true"
              [focusedRowEnabled]="false" [columnAutoWidth]="true" [wordWrapEnabled]="false"
              [rowAlternationEnabled]="false" [allowColumnResizing]="true"
              [allowColumnReordering]="true" (onExporting)="onExportingGridRiepilogo($event)"
              (onCellPrepared)="onCellRiepilogoPrepared($event)">

              <dxo-group-panel [visible]="true"></dxo-group-panel>
              <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>

              <dxo-search-panel [visible]="false"></dxo-search-panel>

              <dxo-sorting mode="none"></dxo-sorting>

              <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

              <dxo-filter-row [visible]="false"></dxo-filter-row>

              <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>

              <dxo-export [enabled]="true"></dxo-export>

              <dxo-paging [pageSize]="20"></dxo-paging>

              <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 20, 50]"></dxo-pager>

              <dxi-column
                dataField="articolo.idTipo"
                caption="Tipologia"
                [groupIndex]="0">
                <dxo-lookup [dataSource]="listTipiArticoliTutti" valueExpr="id" displayExpr="descrizione" ></dxo-lookup>
              </dxi-column>
              <dxi-column
                dataField="articolo.codice"
                caption="Codice Articolo">
              </dxi-column>
              <dxi-column
                dataField="articolo.descrizione"
                caption="Desc Articolo">
              </dxi-column>
              <dxi-column
                dataField="articolo.taglia"
                caption="Taglia">
              </dxi-column>
              <dxi-column
                name="giacenza"
                caption="Giacenza"
                dataType="number"
                [calculateCellValue]="calculateCellValueGiacenza">
              </dxi-column>
              <dxi-column
                dataField="articolo.scortaMinima"
                caption="Scorta Min"
                dataType="number">
              </dxi-column>
              <dxi-column
                dataField="articolo.scortaMassima"
                caption="Scorta Max"
                dataType="number">
              </dxi-column>
              <dxi-column
                dataField="articolo.giorniLeadTime"
                caption="GG Lead Time"
                dataType="number">
              </dxi-column>
              <dxi-column
                dataField="articolo.qtaLottoRiordino"
                caption="Lotto riordino"
                dataType="number">
              </dxi-column>
              <dxi-column
                dataField="numeroNecessari"
                caption="Num Necessari"
                dataType="number">
              </dxi-column>
              <!--
              <dxi-column
                dataField="totDipendentiAssegnati"
                caption="Dip Assegnati"
                dataType="number">
              </dxi-column>
              <dxi-column
                dataField="totConsegnati"
                caption="Consegnati AC"
                dataType="number">
              </dxi-column>
              <dxi-column
                dataField="totConsegnatiAnnoPrec"
                caption="Consegnati Anno Prec"
                dataType="number">
              </dxi-column>    -->


            </dx-data-grid>
          </div>
          <div class="tab-pane fade" id="anomalie" role="tabpanel" aria-labelledby="anomalie-tab">

            <dx-data-grid #dataGridAnomalie [dataSource]="riepilogoRiordinoFisso?.listAnomalie" [showBorders]="true"
              [focusedRowEnabled]="false" [columnAutoWidth]="true" [wordWrapEnabled]="false"
              [rowAlternationEnabled]="false" [allowColumnResizing]="true"
              [allowColumnReordering]="true">

              <dxo-editing
                mode="row"
                [allowAdding]="false"
                [allowUpdating]="false"
                [allowDeleting] ="false"
                [selectTextOnEditStart]="true"
                [useIcons]="true"
                >
                <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>
              </dxo-editing>

              <dxo-paging [pageSize]="25"></dxo-paging>
              <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
              <dxo-filter-row [visible]="true"></dxo-filter-row>
              <dxo-selection mode="multiple"></dxo-selection>

              <dxi-column
                dataField="id"
                [visible]="false"
                [allowEditing]="false">
              </dxi-column>

              <dxi-column
                [allowFiltering]="false"
                [allowSorting]="false" cellTemplate="templateProposta"
                width="35"
                caption="">
              </dxi-column>

              <dxi-column
                name="listTipoProposta"
                caption="Tipo Proposta"
                dataField="tipo">
                <dxo-lookup [dataSource]="listTipoProposta" valueExpr="codice" displayExpr="descrizione"></dxo-lookup>
              </dxi-column>

              <dxi-column
                name="data"
                dataField="dataRif"
                caption="Data Proposta"
                format="dd/MM/yyyy"
                dataType="date">
              </dxi-column>

              <dxi-column
                name="qta"
                dataField="qta"
                caption="Quantità"
                dataType="number">
              </dxi-column>

              <dxi-column
                name="dipendente"
                caption="Dipendente"
                dataField="idDipendente">
                <dxo-lookup [dataSource]="listDipendenti" valueExpr="id" [displayExpr]="getDipendenteDisplayExpr"></dxo-lookup>
              </dxi-column>

              <dxi-column
                name="tipoArticolo"
                caption="Tipo Articolo"
                dataField="idTipoArticolo">
                <dxo-lookup [dataSource]="listTipiArticoli" valueExpr="id" displayExpr="descrizione"></dxo-lookup>
              </dxi-column>

              <dxi-column
                name="articolo"
                caption="Articolo"
                dataField="idArticolo">
                <dxo-lookup [dataSource]="listArticoli" valueExpr="id" [displayExpr]="getArticoloDisplayExpr"></dxo-lookup>
              </dxi-column>

              <dxi-column
                name="dettagli"
                dataField="dettagli">
              </dxi-column>



              <div *dxTemplate="let d of 'templateProposta'">
                @if (d.data.tipo === 'P') {
                  <button class="icon-button" (click)="doAggiornaModello(d.data)">
                    <img
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Aggiorna articoli previsti"
                      alt="Aggiorna articoli previsti"
                      class="grid-icon"
                      src="assets/icons/tshirt.png"
                      />
                    </button>
                  }

                </div>

              </dx-data-grid>
            </div>
          </div>

        </div>

      </div>

    </div><!-- /.card-body -->
  </div>
  <!-- /.card -->

</section>

</div>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="visibleLoadPanel"
  [showIndicator]="true" [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
</dx-load-panel>





